import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Token, TUser } from "./AdminTypes";
import { setTokenSourceMapRange } from "typescript";

export interface IAdminState {
    user: TUser | null,
    token: Token | null
}

const initialState: IAdminState = {
    user: null,
    token: null
};
// action: PayloadAction<HomeLayout>
export const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<TUser | null>) => {
            if (action.payload) {
                state.user = action.payload;
            }
        },
        setToken: (state, action: PayloadAction<any>) => {
            if (action.payload) {
                state.token = action.payload
                localStorage.setItem("token", JSON.stringify(action.payload));
            }
        }
    },
});

export const { setUser, setToken } = adminSlice.actions;

export default adminSlice.reducer;